import Gallery from '../blocks/gallery';

const templateAbout = {
  init() {
    new Gallery('.gallery');
  }
}
export default templateAbout;
